module.exports = __webpack_public_path__ + "static/img/image_support_article_details_p10.dc68d0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_article_details_p10.png
// module id = VcI6
// module chunks = 10